module.exports = __webpack_public_path__ + "img/forBarna1.c2b5923e.png";